module.exports = __webpack_public_path__ + "static/media/hotel_wave.9858ce62.png";